import { EImportSectionsTarget } from '@constants';
import type { ICourse, ISection } from '@sdk/contracts';
import { useState } from 'react';

import { useMutateSection, useMutateCourses } from '@/store';

export const useAddSection = ({
  course,
  target
}: {
  course: ICourse;
  target: EImportSectionsTarget;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const { createSection, isWorking: isSectionWorking } = useMutateSection();
  const { addIntroductionSection, isWorking: isCourseWorking } = useMutateCourses();

  const isIntroduction = target === EImportSectionsTarget.INTRODUCTION;
  const isWorking = isSectionWorking || isCourseWorking;

  const handleSubmit = (
    values: Pick<ISection, 'name' | 'description'>,
    options?: { onSuccess: () => void }
  ) => {
    const submit = isIntroduction ? addIntroductionSection : createSection;

    submit({ course, section: values }, { onSuccess: options?.onSuccess });
  };

  return {
    isIntroduction,
    isWorking,
    handleSubmit,
    isOpen,
    setIsOpen
  };
};
